import './App.css';

import {AnimationOnScroll} from 'react-animation-on-scroll'
import Header from "./components/Header";
import Mainpage from "./components/Mainpage";
import Services from "./components/Services";
import Interior from './components/Interior';
import Door from './components/Door';
import Electrical from './components/Electrical';
import Elevation from './components/Elevation';
import Landscape from './components/Landscape';
import Planning from './components/Planning';
import Contact from './components/Contact';
import About from './components/About';
import { BrowserRouter , Route, Routes } from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Mainpage />
        <AnimationOnScroll animateIn='slipeLeft'>
          <Services style={{margin: "30px 0"}} />
        </AnimationOnScroll>
        <Routes>
          <Route exact path="/" element={null} />
          <Route path="/interior" element={<Interior name='Interior Designing'/>}/>
          <Route path="/kitchen" element={<Interior name='Modular Kitchen'/>}/>
          <Route path="/door" element={<Door/>}/>
          <Route path="/electrical" element={<Electrical/>}/>
          <Route path="/elevation" element={<Elevation/>}/>
          <Route path="/landscape" element={<Landscape/>}/>
          <Route path="/planning" element={<Planning/>}/>
        </Routes>
        <About style={{margin: "30px 0"}}/>
        <Contact style={{margin: "30px 0"}}/>

      </div>
    </BrowserRouter>
  );
}

export default App;
